<template>
    <!-- <div class="menu-content">
        <div class="year-list">
            <div class="year-item" v-for="(item,index) in 5" :key="index">202{{item}}</div>
        </div>
        <div class="classify-list"></div>
    </div> -->
    <van-popup 
        lock-scroll
        v-model="show" 
        position="left" 
        :style="{ width: '100%',height:'100%' }" >
        <div class="menu-content">
            <div class="year-list">
                <div class="year-item" 
                :class="[year_active==item&&active==1?'year-active':'']" 
                v-for="(item,index) in year_list" 
                v-show="!(isMore&&index>2)"
                :key="index"
                @click="active=1,changeYear(item)">{{item}}</div>
                <div class="year-item" :class="isMore||'year-active'" v-if="year_list.length>3" @click="isMore=!isMore">...</div>
            </div>
            
            <div class="classify-list">
                <div class="classify-item" 
                    v-for="(item,index) in nav" 
                    :key="index"
                    :style="active_name==item.name&&active==2?'color:'+item.color+';':''"
                    @click="active=2,changeCassify(item.name)">{{item.name}}</div>
            </div>
        </div>
    </van-popup >
</template>
<script>
    import { workYears } from '../../api'
    import { Popup } from 'vant';
    export default{
        name:"menu",
        props:{
            open:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                active: null,
                show:false,
                year_list:[],
                classify_list:[],
                nav: [{
                    name: 'NEWS',
                    color: '#93278f',
                    path: '/mobile/news',
                    isM: true
                },{
                    name: 'EXHIBITIONS',
                    color: '#0071bc',
                    path: '/mobile/exhibitions',
                    isM: true
                },{
                    name: 'TEXTS',
                    color: 'rgb(238,68,38)',
                    path: '/mobile/texts',
                    isM: true
                },{
                    name: 'BIOGRAPHY',
                    color: '#22b573',
                    path: '/mobile/biography',
                    isM: true
                },{
                    name: 'CONTACT',
                    color: '#13b5b1',
                    path: '/mobile/contact',
                    isM: true
                }],
                active_name:'WORKS',
                year_active: null,
                isMore: true
            }
        },
        components:{
            'van-popup':Popup
        },
        watch:{
            $route:{
                handler:function(val){
                    if(this.active_name==val.name){return}
                    this.active_name=val.name
                },
                immediate:true
            },
            open:{
                handler:function(val){
                    if(val){this.getYear()}
                    if(val==this.show){return}
                    this.show=val
                },
                immediate:true
            },
        },
        methods:{
            changeCassify(path_name){
                this.active_name=path_name
                new Promise((resolve)=>{
                    this.closeMenu(resolve)
                })
                .then(()=>{
                    this.$router.push({
                        name: path_name
                    })
                })
                // console.log("path_name",path_name)
            },
            changeYear(year){
                this.year_active=year
                this.$emit("changeYear",year)
                this.$router.push({path:'/mobile/works',query: {year:year}})
                this.closeMenu()
            },
            closeMenu(resolve){
                setTimeout(()=>{
                    this.show=false
                    this.$emit("update:open",false)
                    if(resolve){resolve()}
                },500)
                
            },
            getYear(){
                workYears({})
                .then(res=>{
                    var data = res.data.data
                    this.year_list = data?data.split(','):[]
                    // var list = JSON.parse(res.data.data)
                    // this.year_list = list

                })

            }
        },
    }
</script>
<style scoped>
    .menu-content{
        text-align:center;
        line-height: 1;
        padding-top:1rem;
    }
    
    .year-list{
        padding-top:.3rem;
    }
    .year-item{
        position: relative;
        margin-top:.85rem;
        font-size: .27rem;
        font-family: Khmer Sangam MN;
        font-weight: 400;
        transition: all linear .3s;
    }
    .classify-list{
        margin-top:1.7rem;
        padding-bottom:1rem;
    }
    .classify-item{
        position: relative;
        font-size: .25rem;
        font-family: Khmer Sangam MN;
        font-weight: 400;
        transition: all linear .3s;
    }
    .year-item:before,
    .classify-item:before{
        content: '';
        position: absolute;
        left:0;
        top:-15px;
        width:100%;
        height:calc(100% + 30px);
        /* background-color: aqua; */
        z-index:-1;
    }
    .classify-item+.classify-item{
        margin-top:.85rem;
    }
    .year-active{
        color:#0000ff;
    }
</style>